export const blogData = [
    {
        id: 2,
        title: 'BOOK MY SHOW CLONE WEBSITE',
        description: 'The Book my show a website for book Movie Theater Tickets according to your Cities.',
        date: 'Apr 3, 2022',
        image: 'https://i.ibb.co/pK0jDbT/BlogSS.jpg',
        url: 'https://medium.com/@alokkumar-dev/bookmyshow-clone-website-78d5e03a27b4'
    },
    {
        id: 3,
        title: 'HOK MAKEUP CLONE WEBSITE',
        description: 'HOK makeup is a website for buying makeup toolkits and accessories from brands across the whole world. HOK makeup brings the most loved beauty brands worldwide to your doorstep.',
        date: 'Mar 17, 2022',
        image: 'https://i.ibb.co/m9hWDpQ/medium.jpg',
        url: 'https://medium.com/@alokshakya2601/hok-makeup-clone-website-e9e15ba97712'
    },
    {
        id: 1,
        title: 'HOW DID OUR TEAM BUILD THE UNIQLO CLONE?',
        description: 'Hi reader, you might have ordered something online right? So, I am sharing my team experience that how we build a clone of the online shopping website “Uniqlo”.',
        date: 'March 15, 2022',
        image: 'https://i.ibb.co/sgk16qM/Uniqlo-clone-blog.jpg',
        url: 'https://medium.com/@alokshakya2601/how-did-our-team-build-the-uniqlo-clone-2fabc2404369'
    }
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/